/**
 * Created by kb on 2017/10/16.
 */
import Vue from 'vue'

//本组件适用于vue2.0-2.3版本

/**
 * 输入小数的组件
 * @type {"vue/types/vue".Vue}
 */
let component= Vue.component('decimal-input', {
  template: `
        <el-input
        ref="input"
        v-model="defValue"
        @keypress.native.stop="updateValue"
        @input.native.stop="input"
        @blur.stop="blur"
        >
        </el-input>`,
  props: {
    //绑定的数据
    value: {
      default:""
    },
    //小数位数
    len: {
      type: Number,
      default: 2
    },
    //整数位数
    intLen: {
      type: Number,
      default: 16
    },
    //输入总长度
    maxLen: {
      type: Number,
      default: 16
    },
    //绑定表体数据  适用于table数据
    row: {
      default: null
    },
    //控件处于tabel的tr行号
    index: {
      type: Number,
      default: 0
    },
  },
  data(){
    return {
      defValue: this.value
    }
  },
  mounted: function () {
    this.formatValue()
  },
  watch:{
    'value':function () {
      if (this.defValue !== this.value) {
        this.defValue = this.value.toString();
        if (this.row == null) {
          if (this._events["update:upValue"]) {
            this.$emit('update:upValue', this.defValue);
          } else {
            this.$emit("on-result-change", this.defValue);
          }
        } else {
          if (this._events["update:upValue"]) {
            this.$emit('update:upValue', this.defValue);
          } else {
            this.$emit("on-result-change", this.defValue, this.row,this.index);
          }
        }
      }
    }
  },
  methods: {
    blur(){
      let cimalReg = new RegExp("^[0-9]{1,}[.]{1,}$");
      if(this.defValue!="" && cimalReg.test(this.defValue)) {
        this.defValue = this.defValue.replace(/[.]/g,"");
      }
      this.$refs.input.currentValue = this.defValue;
      if (this.row == null) {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue);
        }
      } else {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue, this.row, this.index);
        }
      }
    },
    updateValue: function () {
      let event = window.event || event;
      var keyCode = event.keyCode || event.charCode;
      if (keyCode == 8 || (keyCode == 46 && event.code == "Delete") || keyCode == 37 || keyCode == 39) {
        return;
      }
      if ((keyCode >= 48 && keyCode <= 57) || keyCode == 46) {
        if (window.event.target.value.length >= this.maxLen && event.target.selectionStart === event.target.selectionEnd) {
          event.returnValue = false;
          event.preventDefault();
          return;
        }
        let cursurPosition = this.findSelection(event.target);
        if (keyCode === 46) {
          let vs = String.fromCharCode(keyCode);
          if (this.defValue.indexOf(vs) > 0 || this.defValue.length == 0) {
            event.returnValue = false;
            event.preventDefault();
          }
        } else {
          if (event.target.selectionStart === event.target.selectionEnd) {
            if (this.defValue.indexOf(".") > 0 && cursurPosition > this.defValue.indexOf(".")) {
              let vs = String.fromCharCode(keyCode);
              // let aNew = this.defValue.replace(/([^.]*).*/, "$1");
              // aNew = this.defValue.replace(aNew + ".", "").length;
              let decimalLen = this.defValue.substr(this.defValue.indexOf(".") + 1).length;
              if (decimalLen >= this.len) {
                event.returnValue = false;
                event.preventDefault();
              }
            } else {
              if (this.intLen > 0) {
                let intLen = this.defValue.indexOf(".") > 0 ? this.defValue.substr(0, this.defValue.indexOf(".")).length : this.defValue.length;
                if (intLen >= this.intLen) {
                  event.returnValue = false;
                  event.preventDefault();
                }
              }
            }
          }
        }
      }
      else {
        event.returnValue = false;
        event.preventDefault();
      }
    },
    findSelection(demo){
      let cursurPosition = -1;
      if (typeof(demo.selectionStart) == "number") {//非IE浏览器
        cursurPosition = demo.selectionStart;
      } else {//IE
        let range = document.selection.createRange();
        range.moveStart("character", -1 * demo.value.length);
        cursurPosition = range.text.length;
      }
      return cursurPosition;
    },
    input(value){
      this.defValue = this.defValue.replace(/[^\d.]/g, "");
      let cimalReg = new RegExp("^[0-9]{1," + this.intLen + "}([.]{1}[0-9]{0," + this.len + "})?$");
      if(this.defValue!="" && !cimalReg.test(this.defValue)) {
        // let cimalReg2 = new RegExp("[0-9]{1," + this.intLen + "}([.]{1}[0-9]{1," + this.len + "})?", "g");
        // this.defValue.replace(cimalReg2, ($0) => {
        //   console.log($0)
        //   return 1;
        // });
        this.defValue = "";
      }
      this.$refs.input.value = this.$refs.input.currentValue = this.defValue;
      if (this.row == null) {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue);
        }
      } else {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue, this.row, this.index);
        }
      }
    },
    formatValue: function () {
      this.defValue = this.value.toString().replace(/[^\d.]/g, "");
      if(this.row==null) {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue);
        }
      }else{
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue, this.row,this.index);
        }
      }
    }
  }
});

/**
 * 只允许输入整数的组件
 */
Vue.component('integer-input', {
  template: `
      <el-input\
        ref="input"
        v-model="defValue"
        @keypress.native.stop="updateValue"
        @input.native.stop="input">
        </el-input>`,
  props: {
    value: {
      type: String,
      default:""
    },
    //最大输入位数
    maxLen: {
      type: Number,
      default: 16
    },
    row: {
      default: null
    },
    //控件处于tabel的tr行号
    index: {
      type: Number,
      default: 0
    },
  },
  data(){
    return {
      defValue: this.value
    }
  },
  watch:{
    'value':function () {
      if (this.defValue !== this.value) {
        this.defValue = this.value;
        if (this.row == null) {
          if (this._events["update:upValue"]) {
            this.$emit('update:upValue', this.defValue);
          } else {
            this.$emit("on-result-change", this.defValue);
          }
        } else {
          if (this._events["update:upValue"]) {
            this.$emit('update:upValue', this.defValue);
          } else {
            this.$emit("on-result-change", this.defValue, this.row,this.index);
          }
        }
      }
    }
  },
  mounted: function () {
    this.formatValue()
  },
  methods: {
    updateValue: function () {
      let event = window.event || event;
      var keyCode = event.keyCode || event.charCode;
      if (keyCode == 8 || (keyCode == 46 && event.code == "Delete") || keyCode == 37 || keyCode == 39) {
        return;
      }
      if (keyCode >= 48 && keyCode <= 57) {
        if (window.event.target.value.length >= this.maxLen && event.target.selectionStart===event.target.selectionEnd) {
          event.returnValue = false;
          event.preventDefault();
          return;
        }
      }
      else {
        event.returnValue = false;
        event.preventDefault();
      }
    },
    input(value){
      this.defValue = this.defValue.replace(/[^\d]/g, "");
      let cimalReg = new RegExp("^[0-9]{1," + this.maxLen + "}$");
      if(this.defValue!="" && !cimalReg.test(this.defValue)) {
        this.defValue = "";
      }
      this.$refs.input.value = this.$refs.input.currentValue = this.defValue;
      if(this.row==null) {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue);
        }
      }else{
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue, this.row,this.index);
        }
      }
    },
    formatValue: function () {
      this.defValue = this.value.toString().replace(/[^\d]/g, "");
      if(this.row==null) {
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue);
        }
      }else{
        if (this._events["update:upValue"]) {
          this.$emit('update:upValue', this.defValue);
        } else {
          this.$emit("on-result-change", this.defValue, this.row,this.index);
        }
      }
    }
  }
});


export  default  component;



// WEBPACK FOOTER //
// ./src/compnent/input.js